<div class="wrapper-landing-business-page">
  <div class="zc-container">
    <div class="header-business-page">
      <div class="header-business-page-content">
        <span class="header-title-business-page">{{'FOR_BUSINESSES.increase_visibility_and_do_business_for_free' | translate}}</span>
        <span class="header-subtitle-business-page">{{'FOR_BUSINESSES.join_the_app' | translate}} <b>Party Booker</b> {{'FOR_BUSINESSES.and_become_part_of_the_largest_platform_for_organizing_children_s_parties_in_serbia' | translate}} <br>
          {{'FOR_BUSINESSES.be_visible_to_thousands_of_parents_who_are_looking_for_playrooms' | translate}}<br>
        <b>{{'FOR_BUSINESSES.join_today_and_become_part_of_a_story_that_changes_the_way_children_s_birthday_parties_are_organized' | translate}}</b>
        </span>
        <button [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" [state]="{isBusiness: true}" class="custom-btn custom-btn--white">
          <span>{{'FOR_BUSINESSES.become_a_partner' | translate}}</span>
        </button>
        <div class="wrapper-business-categories">
          <div class="wrapper-tag-category">
            <span>{{'FOR_BUSINESSES.decoration' | translate}}</span>
          </div>
          <div class="wrapper-tag-category">
            <span>{{'FOR_BUSINESSES.gifts' | translate}}</span>
          </div>
          <div class="wrapper-tag-category">
            <span>{{'FOR_BUSINESSES.catering' | translate}}</span>
          </div>
          <div class="wrapper-tag-category">
            <span>{{'FOR_BUSINESSES.playrooms' | translate}}</span>
          </div>
          <div class="wrapper-tag-category">
            <span>{{'FOR_BUSINESSES.cakes' | translate}}</span>
          </div>
          <div class="wrapper-tag-category">
            <span>{{'FOR_BUSINESSES.photographers' | translate}}</span>
          </div>
          <div class="wrapper-tag-category">
            <span>{{'FOR_BUSINESSES.animators' | translate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="zc-container">
    <div class="grid">
      <div class="grid__s-12">
        <div class="three-steps-home">
          <div class="wrapper-home-steps">
            <div class="home-step">
              <img src="../../../../assets/images/landing/business/business-step1-illustration.svg" alt="">
              <h4>{{'FOR_BUSINESSES.register_an_account' | translate}}</h4>
              <p>{{'FOR_BUSINESSES.the_first_step_towards_more_clients' | translate}} <br> {{'FOR_BUSINESSES.create_your_free_account_in_the_my_birthday_app_and_present' | translate}}</p>
            </div>
            <img class="line-step-home business-step1" src="../../../../assets/images/landing/line-step.svg" alt="">
            <div class="home-step">
              <img src="../../../../assets/images/landing/business/business-step2-illustration.svg" alt="">
              <h4>{{'FOR_BUSINESSES.fill_in_the_dates' | translate}}</h4>
              <p>{{'FOR_BUSINESSES.enter_your_free_times_and_services' | translate}} <br> {{'FOR_BUSINESSES.no_calls_no_correspondence_no_mistakes' | translate}}</p>
            </div>
            <img class="line-step-home business-step2" src="../../../../assets/images/landing/line-step.svg" alt="">
            <div class="home-step">
              <img src="../../../../assets/images/landing/business/business-step3-illustration.svg" alt="">
              <h4>{{'FOR_BUSINESSES.do_business_with_pleasure' | translate}}</h4>
              <p>{{'FOR_BUSINESSES.each_reservation_is_automatically_confirmed_and_recorded_in_your_profile' | translate}} <br> {{'FOR_BUSINESSES.you_provide_the_service_the_parents_get_the_confirmation' | translate}}
                <br>{{'FOR_BUSINESSES.simple_clear_and_stress_free' | translate}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  -->
  <div class="wrapper-three-step-description">
    <div class="zc-container">
      <div class="grid bg-white-three-step xs-mb-120">
        <div class="grid__llx-6">
          <div class="wrapper-content-step-desc">
            <!--            bez finansijskih obaveza i naknada-->
            <h1>{{'FOR_BUSINESSES.free_app_to_use' | translate}}</h1>
            <p>{{'FOR_BUSINESSES.registration_and_use_of_the_my_birthday_application_are_completely_free_for_business_users' | translate}}</p>
              <br>
            <button [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" class="custom-btn custom-btn--purple xs-mt-20 xs-mb-20 xl-mb-0">
              <span>{{'FOR_BUSINESSES.register' | translate}}</span>
            </button>
          </div>
        </div>
        <div class="grid__llx-6 wrapper-image-step-col">
          <div class="wrapper-image-three-step">
            <img src="../../../../assets/images/landing/illustration-step1-desc.svg" alt="">
          </div>
        </div>
      </div>
      <div class="grid bg-white-three-step two xs-mb-120">
        <div class="grid__llx-6 wrapper-image-step-col">
          <div class="wrapper-image-three-step">
            <img src="../../../../assets/images/landing/illustration-step2-desc.svg" alt="">
          </div>
        </div>
        <div class="grid__llx-6">
          <div class="wrapper-content-step-desc">
            <h1>{{'FOR_BUSINESSES.multiply_your_visibility_among_parents' | translate}}</h1>
            <p>{{'FOR_BUSINESSES.be_where_your_parents_are_looking_for_you' | translate}} <b>Party Studio</b>, {{'FOR_BUSINESSES.your_business_becomes_visible_to_thousands_of_users_who_plan_children_s_parties_every_day' | translate}}</p>
              <br>
            <button [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" class="custom-btn custom-btn--purple xs-mt-20 xs-mb-20 xl-mb-0">
              <span>{{'FOR_BUSINESSES.increase_visibility' | translate}}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="grid bg-white-three-step">
        <div class="grid__llx-6">
          <div class="wrapper-content-step-desc">
            <h1>{{'FOR_BUSINESSES.all_reservations_and_appointments_in_one_place' | translate}}</h1>
            <p>{{'FOR_BUSINESSES.orget_about_chaotic_calendars' | translate}} <b>Party Studio</b> {{'FOR_BUSINESSES.track_all_reservations_and_services_in_real_time' | translate}}</p>
            <br>
            <button [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" class="custom-btn custom-btn--purple xs-mb-20 xl--mb-0">
              <span>{{'FOR_BUSINESSES.see_how_it_works' | translate}}</span>
            </button>
          </div>
        </div>
        <div class="grid__llx-6 wrapper-image-step-col">
          <div class="wrapper-image-three-step">
            <img src="../../../../assets/images/landing/illustration-step3-desc.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  Largest business partners section -->
  <div class="wrapper-business-partner">
    <div class="bg-image-partners"></div>
    <div class="zc-container">
      <div class="wrapper_largest_business_partners">
        <div class="wrapper-icon-slider-business-partner">
          <img src="../../../../assets/icons/landing/icon-star-blue.svg" alt="">
        </div>
        <div class="wrapper-icon-slider-business-partner-red">
          <img src="../../../../assets/icons/landing/icon-star-blue.svg" alt="">
        </div>
        <div class="grid">
          <div class="grid__s-12">
            <span class="small-title">{{'FOR_BUSINESSES.our_business_partners' | translate}}</span>
          </div>
        </div>
        <div class="grid">
          <div *ngFor="let partner of businessPartners" class="grid__m-4">
            <a *ngIf="banners.F?.length && banners.F[partner]" [href]="banners.F[partner].link" target="_blank">
              <div class="wrapper-banner-image-largest-business">
                <img [src]="banners.F[partner].image.full_path" alt="">
              </div>
            </a>
            <div *ngIf="!banners.F?.length || !banners.F[partner]" class="wrapper-banner-empty">
              <img class="yellow-icon-banner" src="../../../../assets/icons/landing/illustration/illustration-yellow-empty-banner.svg" alt="">
              <img class="r-empty-banner" src="../../../../assets/icons/landing/illustration/illustration-r-empty-banner.svg" alt="">
              <div class="content-empty-banner">
                <img src="../../../../assets/icons/landing/illustration/white-r.svg" alt="">
                <span>{{'GLOBAL.place_for' | translate}}</span>
                <span><b>{{'GLOBAL.your_advertisement' | translate}}</b></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FAQ section -->
  <div class="wrapper-faq-section">
    <div class="zc-container">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-faq">
            <div class="wrapper-title faq">
              <h2>{{'FOR_BUSINESSES.frequent' | translate}} <span>{{'FOR_BUSINESSES.questions' | translate}}</span></h2>
              <img src="../../../../assets/icons/landing/illustration/faq-illustration.svg" alt="">
            </div>
            <div class="wrapper-content-faq">
              <div *ngFor="let faq of faqs; index as faqIndex" class="wrapper-question" (click)="faqIndex === activeFaqIndex ? activeFaqIndex = -1 : activeFaqIndex = faqIndex"  [ngClass]="{'collapsed': faqIndex === activeFaqIndex}">
                <span class="title-question">{{ faq.question }}</span>
                <span class="description-answer">{{ faq.answer }}</span>
                <img class="icon-star-green rotating" src="../../../../assets/icons/landing/icon-star-green.svg" alt="">
                <img class="icon-blue plus" src="../../../../assets/icons/landing/icon-plus-blue.svg" alt="">
                <img class="icon-blue minus" src="../../../../assets/icons/landing/Icon-minus-blue.svg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section -->
  <div class="wrapper-newsletter">
    <span class="title-newsletter">{{'FOR_BUSINESSES.sign_up_and_get_the_latest_information' | translate}}</span>
    <span class="subtitle-newsletter">{{'FOR_BUSINESSES.sign_up_and_be_the_first_to_know_about_new_games_gifts_and_promotions' | translate}}</span>
    <form [formGroup]="newsletterForm" (ngSubmit)="onSubmitPostNewsletterForm()" class="form-newsletter">
      <div class="wrapper-input-landing">
        <div class="custom-input">
          <input [formControl]="newsletterForm.controls.email | formControl" type="text" placeholder="">
        </div>
        <!--   TODO TRANSLATE ZOCA     -->
        <span class="error-message">{{newsletterForm.controls.email | formControlErrorMessages: 'Unesite validnu email adresu.' : newsletterFormTriedToSubmit}}</span>
      </div>
      <button type="submit" class="custom-btn custom-btn--purple">
        <span>{{'GLOBAL.send' | translate}}</span>
      </button>
    </form>
  </div>
</div>
